import {  util } from '@seims/shared';

const NYSColumns = [
    "Intake Financial Year", 
    "ID Number",
    "Disability",
    "Gender",
    "Race",	
    "Home Province",
    "Preferred Placement Province",
    "Qualification",
    "Pre-NYS Activity",
    "Placement Province",
    "Placement Date",
    "Exit Direction",
    "Exit Date"
  ];


  const NYSDataColumns = [
    {
      title: (
        <span
          style={{
            color: !NYSColumns.includes("Intake Financial Year")
              ? "red"
              : "inherit",
          }}
        > 
          Intake Financial Year
        </span>
      ),
      dataIndex: "Intake Financial Year",
      key: "1",
      fixed: "left",
      width: 200,
      ellipsis: true,
    },
   
    {
      title: (
        <span
          style={{
            color: !NYSColumns.includes("ID Number")
              ? "red"
              : "inherit",
          }}
        >
          ID Number
        </span>
      ),
      dataIndex: "ID Number",
      key: "3",
      width: 170,
    },
    {
      title: (
        <span
          style={{
            color: !NYSColumns.includes("Disability")
              ? "red"
              : "inherit",
          }}
        >
          Disability
        </span>
      ),
      dataIndex: "Disability",
      key: "4",
      width: 100,
    },
    {
      title: (
        <span
          style={{
            color: !NYSColumns.includes("Gender")
              ? "red"
              : "inherit",
          }}
        >
          Gender
        </span>
      ),
      dataIndex: "Gender",
      key: "5",
      width: 100,
    },
    {
      title: (
        <span
          style={{
            color: !NYSColumns.includes("Race")
              ? "red"
              : "inherit",
          }}
        >
          Race
        </span>
      ),
      dataIndex: "Race",
      key: "6",
      width: 100,
    },
    {
      title: (
        <span
          style={{
            color: !NYSColumns.includes("Home Province")
              ? "red"
              : "inherit",
          }}
        >
          Home Province
        </span>
      ),
      dataIndex: "Home Province",
      width: 150,
      key: "7",
    },
    {
      title: (
        <span
          style={{
            color: !NYSColumns.includes("Preferred Placement Province")
              ? "red"
              : "inherit",
          }}
        >
          Preferred Placement Province
        </span>
      ),
      dataIndex: "Preferred Placement Province",
      width: 150,
      key: "8",
    },
    {
      title: (
        <span
          style={{
            color: !NYSColumns.includes("Qualification")
              ? "red"
              : "inherit",
          }}
        >
          Qualification
        </span>
      ),
      dataIndex: "Qualification",
      key: "10",
      width: 150,
    },
    {
      title: (
        <span
          style={{
            color: !NYSColumns.includes("Pre-NYS Activity")
              ? "red"
              : "inherit",
          }}
        >
          Pre-NYS Activity
        </span>
      ),
      dataIndex: "Pre-NYS Activity",
      key: "11",
      width: 150,
    },
    {
      title: (
        <span
          style={{
            color: !NYSColumns.includes("Placement Province")
              ? "red"
              : "inherit",
          }}
        >
          Placement Province
        </span>
      ),
      dataIndex: "Placement Province",
      key: "12",
      width: 200,
      ellipsis: true,
    },
    {
      title: (
        <span
          style={{
            color: !NYSColumns.includes("Placement Date")
              ? "red"
              : "inherit",
          }}
        >
          Placement Date
        </span>
      ),
      dataIndex: "Placement Date",
      key: "13",
      width: 120,
      render: (x) => (util.fromExcelNumDateToDate(x))

    },
    {
      title: (
        <span
          style={{
            color: !NYSColumns.includes("Exit Direction")
              ? "red"
              : "inherit",
          }}
        >
          Exit Direction
        </span>
      ),
      dataIndex: "Exit Direction",
      key: "14",
      width: 120,
    },
    {
      title: (
        <span
          style={{
            color: !NYSColumns.includes("Exit Date")
              ? "red"
              : "inherit",
          }}
        >
          Exit Date
        </span>
      ),
      dataIndex: "Exit Date",
      key: "15",
      width: 120,
      render: (x) => (util.fromExcelNumDateToDate(x))

    },
  ];
  
  export default { NYSDataColumns, NYSColumns };